import { InMemoryCache, makeVar } from '@apollo/client';
import { CustomError } from 'apollo/types';

export const useMocksCache = makeVar<boolean>(false);
export const showErrorModal = makeVar<boolean>(false);
export const errorData = makeVar<CustomError | null>(null);

const cache = new InMemoryCache({});

export default cache;
